import React from 'react';
import PropTypes from 'prop-types';

import Icon from '~/core/scripts/components/Icon';
import Button from '~/scripts/components/Button';

const DropdownIndicator = ({ hasValue, getValue, selectOption }) => {
  const onClick = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    if (hasValue) {
      selectOption(getValue()[0]);
    }
  };

  return (
    <Button insideInput onTouchEnd={onClick} onMouseDown={onClick}>
      <Icon type="search" height={16} width={16} />
    </Button>
  );
};

DropdownIndicator.displayName = 'DropdownIndicator';

DropdownIndicator.propTypes = {
  hasValue: PropTypes.bool,
  getValue: PropTypes.func.isRequired,
  selectOption: PropTypes.func.isRequired,
};

export default DropdownIndicator;
